import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    referralList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    referralDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    getReferralList: (state, action) => {
        state.referralList.requesting = true;
        state.referralList.error = null;
        state.referralList.items = [];
        state.referralList.success = false;
        state.referralList.filters = action.payload;
    },
    getReferralListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.referralList.requesting = false;        
        state.referralList.items = data;
        state.referralList.success = true; 
        state.referralList.pagination.current_page = current_page;
        state.referralList.pagination.per_page = per_page;
        state.referralList.pagination.total = total;
    },
    getReferralListFail: (state, action) => {        
        state.referralList.requesting = false;
        state.referralList.error = action.payload;
    },
    getReferralDetails: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },
    getReferralDetailsSuccess: (state, action) => {
        state.referralDetails.requesting = false;
        state.referralDetails.data = action.payload;
        console.log(action);
        state.referralDetails.success = true; 
    },
    getReferralDetailsFail: (state, action) => {        
        state.referralDetails.requesting = false;
        state.referralDetails.error = action.payload;
    },
    doReferralCreate: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },
    doReferralUpdate: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },
    doReferralDelete: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },

    getReferralCodeDetails: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },

    doReferralRegistration: (state) => {
        state.referralDetails.requesting = true;
        state.referralDetails.error = null;
        state.referralDetails.data = null;
        state.referralDetails.success = false; 
    },

  },
})

export const { 
    getReferralList, getReferralListSuccess, getReferralListFail,
    getReferralDetails, getReferralDetailsSuccess, getReferralDetailsFail,
    doReferralCreate, doReferralUpdate, doReferralDelete,
    getReferralCodeDetails, doReferralRegistration
} = referralSlice.actions

export default referralSlice.reducer